'use client';

import { useRouter } from 'next/navigation';

import Popup from '@/components/elements/Popup';
import { usePopup } from '@/features/stores/popup-store';

function PaywallDialog() {
  const { open, close } = usePopup();
  const router = useRouter();

  return (
    <Popup isOpen={open} onClose={close} title="Free limit reached">
      <div className="mb-6">
        <p>
          You’ve used all your free searches. Upgrade to continue getting instant expert answers.
        </p>
      </div>
      <div className="flex justify-end gap-2">
        <button className="rounded-md border px-4 py-2 text-sm" onClick={close}>
          Not now
        </button>
        <button
          className="bg-primary text-text rounded-md px-4 py-2 text-sm"
          onClick={() => {
            close();
            router.push('/subscription');
          }}
        >
          Upgrade
        </button>
      </div>
    </Popup>
  );
}
export default PaywallDialog;
